import type { Highlight, Highlights } from '../../interface/Highlight';
import { useSession } from 'next-auth/react';
import { useQuery } from '@tanstack/react-query';
import { api } from '@/libs/axios/api';
import { apiConfig } from '@/config/api';

export const useGetHighlights = () => {
  const { data: session } = useSession();

  const url =
    session && session.access_token
      ? apiConfig.routes.crossSell.highlights
      : apiConfig.routes.crossSell.highlightsPublic;

  return useQuery({
    queryKey: ['cross-sell', 'highlights', url],
    queryFn: () => getHighlights(url),
  });
};

const getHighlights = async (url: string): Promise<Highlight[]> => {
  const { data } = await api.get<Highlights>(url, {
    params: {
      keep_watch_contents_limit: 3,
    },
  });
  return data.items;
};
